import { motion } from "framer-motion";
import { IMAGES } from "@/lib/constants";

const ease = [0.16, 1, 0.3, 1];

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="bg-cream-alt py-24 sm:py-32 lg:py-40"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.9, ease }}
            className="lg:col-span-6 order-2 lg:order-1"
          >
            <span className="eyebrow">Qui nous sommes</span>
            <h2 className="mt-4 font-serif text-charcoal text-4xl sm:text-5xl lg:text-6xl leading-[1.05] font-normal">
              <span className="sr-only">Entreprise Familiale de Bâtiment à Grand-Lancy, Genève. </span>
              Une famille.
              <br />
              Un nom. <span className="italic text-bronze">Une promesse.</span>
            </h2>

            <div className="mt-10 space-y-6 text-charcoal-muted text-base lg:text-lg leading-relaxed font-light max-w-xl">
              <p>
                Confier son chez-soi à des inconnus, on sait à quel point c'est stressant.
                Chez DEM BAT, vous traitez avec <span className="text-charcoal">la famille Demiri</span>.
                Pas un commercial qui disparaît après la signature.
              </p>
              <p>
                Le même artisan suit votre chantier du premier coup de truelle au dernier coup de pinceau.
                Vous savez qui vient, quand, et ce qui se passe chez vous. Et si quelque chose ne va pas
                après les travaux, vous appelez : on revient.
              </p>
            </div>

            <div className="mt-12 grid grid-cols-2 sm:grid-cols-4 gap-x-4 gap-y-8 pt-10 border-t border-border">
              <div>
                <div className="font-serif text-3xl lg:text-4xl text-bronze">20+</div>
                <div className="mt-1 text-[10px] uppercase tracking-widest text-charcoal-muted">Années</div>
              </div>
              <div>
                <div className="font-serif text-3xl lg:text-4xl text-bronze">10+</div>
                <div className="mt-1 text-[10px] uppercase tracking-widest text-charcoal-muted">Équipe</div>
              </div>
              <div>
                <div className="font-serif text-3xl lg:text-4xl text-bronze">100%</div>
                <div className="mt-1 text-[10px] uppercase tracking-widest text-charcoal-muted">Famille</div>
              </div>
              <div>
                <div className="font-serif text-3xl lg:text-4xl text-bronze">24h</div>
                <div className="mt-1 text-[10px] uppercase tracking-widest text-charcoal-muted">Devis</div>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 1.04 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1.1, ease }}
            className="lg:col-span-6 order-1 lg:order-2"
          >
            <div className="relative aspect-[4/5] overflow-hidden">
              <img
                src={IMAGES.about}
                alt="Artisans rénovation famille Demiri DEM BAT à Grand-Lancy Genève, moulures et stucs décoratifs"
                className="w-full h-full object-cover scale-[1.15]"
                style={{ objectPosition: "center 50%" }}
              />
              <div className="absolute bottom-6 left-6 right-6 bg-charcoal-deep/85 backdrop-blur-sm p-6 border-l-2 border-bronze">
                <p className="text-white/90 font-serif text-lg italic leading-snug">
                  « Sur chaque mur, c'est notre nom qu'on signe. »
                </p>
                <p className="mt-3 text-bronze-light text-xs uppercase tracking-widest">
                  Famille Demiri
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
